import { render, staticRenderFns } from "./live-list.vue?vue&type=template&id=09b50ab2&scoped=true&"
import script from "./live-list.vue?vue&type=script&lang=js&"
export * from "./live-list.vue?vue&type=script&lang=js&"
import style0 from "./live-list.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./live-list.vue?vue&type=style&index=1&id=09b50ab2&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b50ab2",
  null
  
)

export default component.exports